import { MultiAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'

export const FieldsHomeGeneral = (
  data,
  optionsWafers,
  productGroup,
  handleChange,
  products,
  edit,
  familys
) => {
  const YN = [
    {
      id: 0,
      optionLabel: 'NO',
    },
    {
      id: 1,
      optionLabel: 'SI',
    },
  ]

  // const TIPO_OBLEA = [
  //   {
  //     id: 1,
  //     label: "Principal",
  //   },
  //   {
  //     id: 2,
  //     label: "Anexa sin control",
  //   },
  //   {
  //     id: 3,
  //     label: "Anexa con control",
  //   },
  // ]
  return [
    {
      id: 1,
      class: 'textfield',
      name: 'producto',
      label: 'Nombre producto',
      value: data.producto,
      disabled: !edit,
      sm: 12,
      xs: 12,
      onChange: (e) => handleChange(data.id, 'producto', e.target.value),
    },
    {
      id: 2,
      class: 'textfield',
      name: 'familia_id',
      label: 'Familia',
      value: familys.find((f) => f.id === data.familia_id)?.descripcion || '',
      sm: 4,
      xs: 12,
      disabled: true,
    },
    {
      class: 'autocomplete',
      sm: 4,
      xs: 12,
      name: 'conf_oblea',
      label: 'Pieza de oblea',
      optionValue: 'value',
      options: optionsWafers,
      optionLabel: `options["oblea_rudac"]`,
      value: data.conf_oblea,
      disabled: !edit,
      defaultValue: optionsWafers.find((v) => v.id === data.conf_oblea),
      onChange: (e) => handleChange(data.id, 'conf_oblea', e.id),
    },
    {
      class: 'autocomplete',
      sm: 4,
      xs: 12,
      name: 'activo',
      label: 'Activo',
      optionValue: 'value',
      options: YN,
      optionLabel: `options["optionLabel"]`,
      value: data.activo,
      disabled: !edit,
      defaultValue: YN.find((v) => v.id === data.activo),
      onChange: (e) => handleChange(data.id, 'activo', e.id),
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="pieza_madre"
          options={products}
          getOptionLabel={(e) => e.producto}
          value={products.filter((p) =>
            data?.pieza_madre?.length > 0
              ? data.pieza_madre.includes(p.id)
              : data.subpiezas_asociadas?.some((sp) => sp.pieza_madre_id === p.id)
          )}
          label="Pertenece a conjunto"
          onChange={(_, value) => {
            handleChange(
              data.id,
              'pieza_madre',
              value.map((v) => v.id)
            )
            handleChange(
              data.id,
              'subpiezas_asociadas',
              value.map((v) => v.id)
            )
          }}
          tagName="producto"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 12,
      xs: 12,
    },
  ]
}

export const FieldsHomeConf = (data, optionsWafers, productGroup, handleChange, products, edit) => {
  const YN = [
    {
      id: 0,
      optionLabel: 'NO',
    },
    {
      id: 1,
      optionLabel: 'SI',
    },
  ]

  return [
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'colocado',
      label: 'Stock colocado',
      optionValue: 'value',
      options: YN,
      optionLabel: `options["optionLabel"]`,
      value: data.colocado,
      disabled: !edit,
      defaultValue: YN.find((v) => v.id === data.colocado),
      onChange: (e) => handleChange(data.id, 'colocado', e.id),
    },
    {
      class: 'textfield',
      sm: 6,
      xs: 12,
      name: 'orden_colocado',
      label: 'Orden colocados',
      value: data.orden_colocado,
      type: 'number',
      disabled: !data.colocado ? true : !edit,
      inputProps: { min: 1 },
      onChange: (e) => {
        const value = e.target.value
        if (value === '' || parseInt(value) > 0) {
          handleChange(data.id, 'orden_colocado', value)
        }
      },
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'grupo_colocado',
      label: 'Grupo colocado',
      optionValue: 'value',
      options: productGroup,
      optionLabel: `options["value"]`,
      value: data.grupo_colocado,
      disabled: !data.colocado ? true : !edit,
      defaultValue: productGroup.find((v) => v.value === data.grupo_colocado),
      onChange: (e) => handleChange(data.id, 'grupo_colocado', e.value),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'taller',
      label: 'Preparación: taller',
      optionValue: 'value',
      options: YN,
      disabled: !edit,
      optionLabel: `options["optionLabel"]`,
      value: data.taller,
      defaultValue: YN.find((v) => v.id === data.taller),
      onChange: (e) => handleChange(data.id, 'taller', e.id),
    },
    {
      class: 'autocomplete',
      sm: 4,
      xs: 12,
      name: 'foto',
      label: 'Foto obligatoria',
      optionValue: 'value',
      options: YN,
      optionLabel: `options["optionLabel"]`,
      value: data.foto,
      defaultValue: YN.find((v) => v.id === data.foto),
      disabled: !data.colocado ? true : !edit,
      onChange: (e) => handleChange(data.id, 'foto', e.id),
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'peso',
      label: 'Peso (kg)',
      value: data.peso,
      type: 'number',
      disabled: !edit,
      onChange: (e) => handleChange(data.id, 'peso', e.target.value),
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'limite',
      label: 'Límite',
      disabled: !edit,
      value: data.limite == null ? null : Math.max(0, parseInt(data.limite) || 0),
      type: 'number',
      onChange: (e) => handleChange(data.id, 'limite', e.target.value),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'es_registral',
      label: 'Es registral?',
      optionValue: 'value',
      options: YN,
      optionLabel: `options["optionLabel"]`,
      value: data.es_registral,
      disabled: !edit,
      defaultValue: YN.find((v) => v.id === data.es_registral),
      onChange: (e) => handleChange(data.id, 'es_registral', e.id),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'es_chasis',
      label: 'Es chasis?',
      optionValue: 'value',
      options: YN,
      optionLabel: `options["optionLabel"]`,
      value: data.es_chasis,
      disabled: !edit,
      defaultValue: YN.find((v) => v.id === data.es_chasis),
      onChange: (e) => handleChange(data.id, 'es_chasis', e.id),
    },
  ]
}

export const FieldsQualities = (
  optionsProducts,
  optionsWafers,
  productGroup,
  handleChange,
  products,
  edit
) => {
  return [
    {
      id: 1,
      class: 'textfield',
      label: 'Excelente',
      name: 'calidad[0].excelente_detalle',
      value: optionsProducts.calidad[0].excelente_detalle,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) =>
        handleChange(optionsProducts.id, 'calidad[0].excelente_detalle', e.target.value),
    },
    {
      id: 2,
      class: 'textfield',
      label: 'Bueno',
      name: 'calidad[0].bueno_detalle',
      value: optionsProducts.calidad[0].bueno_detalle,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => handleChange(optionsProducts.id, 'calidad[0].bueno_detalle', e.target.value),
    },
    {
      id: 3,
      class: 'textfield',
      label: 'Regular',
      name: 'calidad[0].regular_detalle',
      value: optionsProducts.calidad[0].regular_detalle,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) =>
        handleChange(optionsProducts.id, 'calidad[0].regular_detalle', e.target.value),
    },
    {
      id: 4,
      class: 'textfield',
      label: 'Malo',
      name: 'calidad[0].malo_detalle',
      value: optionsProducts.calidad[0].malo_detalle,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => handleChange(optionsProducts.id, 'calidad[0].malo_detalle', e.target.value),
    },
    {
      id: 5,
      class: 'textfield',
      label: 'A preparar',
      name: 'calidad[0].a_preparar',
      value: optionsProducts.calidad[0].a_preparar,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => handleChange(optionsProducts.id, 'calidad[0].a_preparar', e.target.value),
    },
    {
      id: 6,
      class: 'textfield',
      label: 'Scrap',
      name: 'calidad[0].scrap',
      value: optionsProducts.calidad[0].scrap,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => handleChange(optionsProducts.id, 'calidad[0].scrap', e.target.value),
    },
    {
      id: 7,
      class: 'textfield',
      label: 'Nuevo',
      name: 'calidad[0].nuevo',
      value: optionsProducts.calidad[0].nuevo,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => handleChange(optionsProducts.id, 'calidad[0].nuevo', e.target.value),
    },
  ]
}
